import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatStepperModule } from "@angular/material/stepper";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { AccordionModule } from "primeng/accordion";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { RoundProgressModule } from "angular-svg-round-progressbar";
import { PhoUiComponentsModule } from "@ab-inbev-analytics/pho-ui-components";

// Domain-specific components that stay in pho-frontend
import { DecisionTreeComponent } from "./decision-tree/decision-tree.component";
import { RenderedDecisionTreeComponent } from "./decision-tree/rendered-decision-tree.component";
import { NestingSummaryCardsComponent } from "./nesting-summary-cards/nesting-summary-cards.component";
import { NestingSummary } from "./nesting-summary/nesting-summary.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { PortfolioAccordionComponent } from "./portfolio-accordion/portfolio-accordion.component";
import { PortfolioHealthIndex } from "./portfolio-health-index/portfolio-health-index.component";
import { RedirectPendingApprovalComponent } from "./redirect-pending-approval/redirect-pending-approval.component";
import { RequestAccessDialogComponent } from "./request-access-dialog/request-access-dialog.component";
import { ShareExperimentComponent } from "./share-experiment/share-experiment.component";
import { SupportTicketComponent } from "./support-ticket/support-ticket.component";
import { VILCOpportunitiesComponent } from "./vilc-opportunities/vilc-opportunities.component";
import { AbiNpsSurveyDialogComponent } from "./abi-nps-survey-dialog/abi-nps-survey-dialog.component";

@NgModule({
  declarations: [
    // Domain-specific components only
    DecisionTreeComponent,
    NestingSummaryCardsComponent,
    NestingSummary,
    NotFoundComponent,
    PortfolioAccordionComponent,
    PortfolioHealthIndex,
    RedirectPendingApprovalComponent,
    RequestAccessDialogComponent,
    ShareExperimentComponent,
    SupportTicketComponent,
    VILCOpportunitiesComponent,
    AbiNpsSurveyDialogComponent,
  ],
  imports: [
    RenderedDecisionTreeComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    MatStepperModule,
    NgSelectModule,
    AccordionModule,
    DragDropModule,
    RoundProgressModule,
    // Library provides all shared/generic components, pipes, directives, and re-exports UI modules
    PhoUiComponentsModule,
  ],
  exports: [
    RenderedDecisionTreeComponent,
    // Re-export the library so consumers of SharedModule get everything
    PhoUiComponentsModule,
    RoundProgressModule,
    // Domain-specific exports
    DecisionTreeComponent,
    NestingSummaryCardsComponent,
    NestingSummary,
    NotFoundComponent,
    PortfolioAccordionComponent,
    PortfolioHealthIndex,
    RedirectPendingApprovalComponent,
    RequestAccessDialogComponent,
    ShareExperimentComponent,
    SupportTicketComponent,
    VILCOpportunitiesComponent,
    AbiNpsSurveyDialogComponent,
    // Re-export common modules that feature modules may need
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    NgSelectModule,
  ],
})
export class SharedModule {}
